import { render, staticRenderFns } from "./full-bs.vue?vue&type=template&id=5fce4f49"
import script from "./full-bs.vue?vue&type=script&lang=js"
export * from "./full-bs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports